
import { Component, Prop, Vue } from "vue-property-decorator";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import {ICorp} from "@/modules/Corps/interfaces/corp.interface";
import {IApp} from "@/interfaces/app.interface";

@Component({})
export default class CarsCell extends Vue {
  @Prop() cell: IAppTable.ITableProp;
  @Prop() entity: ICorp.IEntity;
  @Prop() index: number;

  async openCarList() {
    let filters = {
      fltCorpId: this.entity.id
    };
    window.open(`${IApp.RoutePath[IApp.ROUTE_NAME.PAGE_CAR_LIST]}?filters=${JSON.stringify(filters)}`, '_blank');
  }
}
